export const FILTER_OPTIONS = {
  ID: 'searchId',
  BITRIX_ID: 'bitrixId',
  AGENCY_ID: 'agencyId',
  TRADESMAN_ID: 'tradesmanId',
  CONTRACT_CODE: 'contractCode',
}

const COMMON_FILTERS = [
  {
    name: FILTER_OPTIONS.ID,
    label: 'ID',
    type: 'text',
  },
  {
    name: FILTER_OPTIONS.BITRIX_ID,
    label: 'ID do Bitrix',
    type: 'text',
  },
]

const INSPECTION_BUDGET_FILTERS = [
  {
    name: FILTER_OPTIONS.AGENCY_ID,
    label: 'Intermediária',
    type: 'autocomplete',
    options: [],
  },
  {
    name: FILTER_OPTIONS.TRADESMAN_ID,
    label: 'Prestador',
    type: 'autocomplete',
    options: [],
  },
]

const INSURANCE_BUDGET_FILTERS = [
  {
    name: FILTER_OPTIONS.CONTRACT_CODE,
    label: 'Código do contrato',
    type: 'text',
  },
  {
    name: FILTER_OPTIONS.AGENCY_ID,
    label: 'Intermediária',
    type: 'autocomplete',
    options: [],
  },
]

export const FILTERS = budgetType => [
  ...COMMON_FILTERS,
  ...(budgetType === 'inspection' ? INSPECTION_BUDGET_FILTERS : []),
  ...(budgetType === 'insurance' ? INSURANCE_BUDGET_FILTERS : []),
]

export const DEFAULT_FILTER = {
  searchId: '',
  bitrixId: '',
  agencyId: '',
  tradesmanId: '',
  contractCode: '',
}

export const INSURANCE_AREA_OF_ACTIVITY = 'Garantidora'
